export default "__VITE_ASSET__TPUeRc8D__"